import { pipe } from 'fp-ts/function';
import * as S from 'fp-ts/string';
import * as RONEA from 'fp-ts/ReadonlyNonEmptyArray';
import { removeQueryString } from '@infl-ts/util-url';
export var filename = function filename(url) {
  return pipe(url, S.split('/'), RONEA.last, removeQueryString);
};